
import { Injectable } from '@angular/core';
import { RequestHelperProvider } from './request-helper';
import { CustomerRequest } from '../_models/customer/customer-request.model';
import { CustomerDetails } from '../_models/customer/customer-details.model';

import utils from './../utils';
import { CustomerCredit } from '../_models/customer/customer-credit.model';
import { UtilServiceProvider } from './util.service';
import { StorageKeys } from '../_constants';
import { StorageServiceProvider } from './services';

@Injectable({
    providedIn: 'root'
})
export class CustomerServiceProvider {

    constructor(private helper: RequestHelperProvider,
        private utilService: UtilServiceProvider,
        private storage: StorageServiceProvider) {
    }
    public GetCustomersLive(customerRequest: CustomerRequest, callback, faildcallback, emailType = "") {

        let tenantID = this.storage.getTenantID();
        if (!tenantID)
            return;
        this.syncCustomersLive(tenantID, ``, customerRequest.name, customerRequest.city, customerRequest.phoneNumber, customerRequest.nameId,
            (res) => {
                let returnarray: CustomerDetails[] = [];
                for (var i = 0; i < res.length; i++) {
                    let resultvalue = new CustomerDetails();
                    resultvalue.name = res[i].NameDescription;
                    resultvalue.city = res[i].City;
                    resultvalue.state = res[i].State;
                    resultvalue.nameId = res[i].NameID;
                    resultvalue.Id = res[i].NameID;
                    resultvalue.phoneNumber = res[i].PhoneNumber;
                    resultvalue.accountSinceDate = res[i].AccountSinceDate;
                    resultvalue.accumulatePatronage = res[i].AccumulatePatronage;
                    resultvalue.activeStatus = res[i].ActiveStatus;
                    resultvalue.accountSinceDate = res[i].accountSinceDate;
                    resultvalue.addressLine1Partial = res[i].AddressLine1Partial;
                    resultvalue.addressLine2Partial = res[i].AddressLine2Partial;
                    resultvalue.bankDefaultACP = res[i].BankDefaultACP;
                    resultvalue.bankDefaultACR = res[i].BankDefaultACR;
                    resultvalue.bankDefaultGRNCheck = res[i].BankDefaultGRNCheck;
                    resultvalue.bankDefaultGRNReceipt = res[i].BankDefaultGRNReceipt;
                    resultvalue.chargeTax1 = res[i].ChargeTax1;
                    resultvalue.chargeTax2 = res[i].ChargeTax2;
                    resultvalue.chargeTax3 = res[i].ChargeTax3;
                    resultvalue.chargeTax4 = res[i].ChargeTax4;
                    resultvalue.cityPartial = res[i].CityPartial;
                    resultvalue.commodityDiscountTable = res[i].CommodityDiscountTable;
                    resultvalue.country = res[i].Country;
                    resultvalue.currencyCode = res[i].CurrencyCode;
                    resultvalue.deferredPayDate = res[i].DeferredPayDate;
                    resultvalue.financeChargeTable = res[i].FinanceChargeTable;
                    resultvalue.invoiceTerms = res[i].InvoiceTerms;
                    resultvalue.misc1Code = res[i].Misc1Code;
                    resultvalue.misc2Code = res[i].Misc2Code;
                    resultvalue.misc3Code = res[i].Misc3Code;
                    resultvalue.misc3CodeDV = res[i].Misc3CodeDV;
                    resultvalue.misc4Code = res[i].Misc4Code;
                    resultvalue.misc5Code = res[i].Misc5Code;
                    resultvalue.misc6Code = res[i].Misc6Code;
                    resultvalue.nameIdType = res[i].NameIdType;
                    resultvalue.nameIdTypeDV = res[i].NameIdTypeDV;
                    resultvalue.namePartial1of3 = res[i].NamePartial1of3;
                    resultvalue.namePartial2of3 = res[i].NamePartial2of3;
                    resultvalue.otherReference = res[i].OtherReference;
                    resultvalue.parentNameID = res[i].ParentNameID;
                    resultvalue.priceLevel = res[i].PriceLevel;
                    resultvalue.priceSchedule = res[i].PriceSchedule;
                    resultvalue.purchaseCreditLimit = res[i].PurchaseCreditLimit;
                    resultvalue.remark1 = res[i].Remark1;
                    resultvalue.remark2 = res[i].Remark2;
                    resultvalue.requireTheirDocumentNumber = res[i].RequireTheirDocumentNumber;
                    resultvalue.salesCreditLimit = res[i].SalesCreditLimit;
                    resultvalue.socialSecurityFederalId = res[i].SocialSecurityFederalId;
                    resultvalue.stateCode = res[i].StateCode;
                    resultvalue.tran1Code = res[i].Tran1Code;
                    resultvalue.tran2Code = res[i].Tran2Code;
                    resultvalue.tran3Code = res[i].Tran3Code;
                    resultvalue.tran4Code = res[i].Tran4Code;
                    resultvalue.tran5Code = res[i].Tran5Code;
                    resultvalue.voucherTerms = res[i].VoucherTerms;
                    resultvalue.zipCode = res[i].ZipCode;
                    resultvalue.cityStateZip = res[i].CityStateZip;
                    resultvalue.createdBy = res[i].CreatedBy;
                    resultvalue.createdDate = res[i].CreatedDate;
                    resultvalue.lastUpdatedBy = res[i].LastUpdatedBy;
                    resultvalue.lastUpdatedDate = res[i].LastUpdatedDate;
                    resultvalue.sqlID = res[i].SQLID;
                    resultvalue.tenantID = res[i].TenantID;
                    resultvalue.alternate = res[i].Alternate;
                    resultvalue.billToRemitTo = res[i].BillToRemitTo;
                    resultvalue.collectionPoint = res[i].CollectionPoint;
                    resultvalue.contactDetails = res[i].ContactDetails;
                    resultvalue.contactRemarks = res[i].ContactRemarks;
                    resultvalue.farms = res[i].Farms;
                    resultvalue.federalRegisteredName = res[i].FederalRegisteredName;
                    //    resultvalue.licenses =  res[i].ProductLicenses ? res[i].ProductLicenses.Items.filter(i=>i).map(d => { let obj = d; delete obj._Entity; return obj }) : null;
                    resultvalue.licenses = res[i].ProductLicenses ? res[i].ProductLicenses : null;
                    resultvalue.addressline1 = res[i].AddressLine1;
                    resultvalue.addressline2 = res[i].AddressLine2;
                    if (res[i].ContactDetails) {
                        resultvalue.primaryContact =
                            res[i].ContactDetails.filter((contactDetail) => {
                                return contactDetail.ContactCategory == "E" && contactDetail.PrimaryContact == "Y" && contactDetail.NameID == resultvalue.nameId;
                            });
                    }
                    let contacts: any = resultvalue.contactDetails;
                    if (contacts && contacts.length > 0) {
                        contacts = contacts.filter((x: any) => x.ContactType == emailType) || [];
                        contacts = contacts.filter((x: any) => x.NameID == resultvalue.nameId) || [];
                        if (contacts.length > 0) {
                            contacts = contacts.filter((x: any) => this.utilService.validateEmail(x.ContactInformation) == true);
                            resultvalue.mailToEmails = contacts.map((x: any) => x.ContactInformation).join(";");
                            resultvalue.mailToEmails = resultvalue.mailToEmails + ';';
                        }
                    }
                    resultvalue.primaryContact = resultvalue.primaryContact.length > 0 ? resultvalue.primaryContact[0] : '';
                    returnarray.push(resultvalue);
                }
                callback(returnarray)
            }, (error) => {
                faildcallback(error);
            })
    }
    public GetCustomer(customerRequest: CustomerRequest, callback, faildcallback) {
        let tenantID = this.storage.getTenantID();
        if (!tenantID)
            return;

        customerRequest.name = customerRequest.name.replace("'", "''");

        this.helper.PostServerCommand(
            `/culturahub/RESTCommandWebService/ExecuteServerCommand/CustomerProcessor/GetCustomersByNameId?TenantID=${tenantID}&NameID=${customerRequest.name}`, null, (data) => {
                if (data) {
                    let res = [];
                    res = data;
                    let returnarray: CustomerDetails[] = [];
                    for (var i = 0; i < res.length; i++) {
                        let resultvalue = new CustomerDetails();
                        resultvalue.name = res[i].NameDescription;
                        resultvalue.city = res[i].City;
                        resultvalue.state = res[i].State;
                        resultvalue.nameId = res[i].NameID;
                        resultvalue.Id = res[i].NameID;
                        resultvalue.phoneNumber = res[i].PhoneNumber;
                        resultvalue.accountSinceDate = res[i].AccountSinceDate;
                        resultvalue.accumulatePatronage = res[i].AccumulatePatronage;
                        resultvalue.activeStatus = res[i].ActiveStatus;
                        resultvalue.accountSinceDate = res[i].accountSinceDate;
                        resultvalue.addressLine1Partial = res[i].AddressLine1Partial;
                        resultvalue.addressLine2Partial = res[i].AddressLine2Partial;
                        resultvalue.bankDefaultACP = res[i].BankDefaultACP;
                        resultvalue.bankDefaultACR = res[i].BankDefaultACR;
                        resultvalue.bankDefaultGRNCheck = res[i].BankDefaultGRNCheck;
                        resultvalue.bankDefaultGRNReceipt = res[i].BankDefaultGRNReceipt;
                        resultvalue.chargeTax1 = res[i].ChargeTax1;
                        resultvalue.chargeTax2 = res[i].ChargeTax2;
                        resultvalue.chargeTax3 = res[i].ChargeTax3;
                        resultvalue.chargeTax4 = res[i].ChargeTax4;
                        resultvalue.cityPartial = res[i].CityPartial;
                        resultvalue.commodityDiscountTable = res[i].CommodityDiscountTable;
                        resultvalue.country = res[i].Country;
                        resultvalue.currencyCode = res[i].CurrencyCode;
                        resultvalue.deferredPayDate = res[i].DeferredPayDate;
                        resultvalue.financeChargeTable = res[i].FinanceChargeTable;
                        resultvalue.invoiceTerms = res[i].InvoiceTerms;
                        resultvalue.misc1Code = res[i].Misc1Code;
                        resultvalue.misc2Code = res[i].Misc2Code;
                        resultvalue.misc3Code = res[i].Misc3Code;
                        resultvalue.misc3CodeDV = res[i].Misc3CodeDV;
                        resultvalue.misc4Code = res[i].Misc4Code;
                        resultvalue.misc5Code = res[i].Misc5Code;
                        resultvalue.misc6Code = res[i].Misc6Code;
                        resultvalue.nameIdType = res[i].NameIdType;
                        resultvalue.nameIdTypeDV = res[i].NameIdTypeDV;
                        resultvalue.namePartial1of3 = res[i].NamePartial1of3;
                        resultvalue.namePartial2of3 = res[i].NamePartial2of3;
                        resultvalue.otherReference = res[i].OtherReference;
                        resultvalue.parentNameID = res[i].ParentNameID;
                        resultvalue.priceLevel = res[i].PriceLevel;
                        resultvalue.priceSchedule = res[i].PriceSchedule;
                        resultvalue.purchaseCreditLimit = res[i].PurchaseCreditLimit;
                        resultvalue.remark1 = res[i].Remark1;
                        resultvalue.remark2 = res[i].Remark2;
                        resultvalue.requireTheirDocumentNumber = res[i].RequireTheirDocumentNumber;
                        resultvalue.salesCreditLimit = res[i].SalesCreditLimit;
                        resultvalue.socialSecurityFederalId = res[i].SocialSecurityFederalId;
                        resultvalue.stateCode = res[i].StateCode;
                        resultvalue.tran1Code = res[i].Tran1Code;
                        resultvalue.tran2Code = res[i].Tran2Code;
                        resultvalue.tran3Code = res[i].Tran3Code;
                        resultvalue.tran4Code = res[i].Tran4Code;
                        resultvalue.tran5Code = res[i].Tran5Code;
                        resultvalue.voucherTerms = res[i].VoucherTerms;
                        resultvalue.zipCode = res[i].ZipCode;
                        resultvalue.cityStateZip = res[i].CityStateZip;
                        resultvalue.createdBy = res[i].CreatedBy;
                        resultvalue.createdDate = res[i].CreatedDate;
                        resultvalue.lastUpdatedBy = res[i].LastUpdatedBy;
                        resultvalue.lastUpdatedDate = res[i].LastUpdatedDate;
                        resultvalue.sqlID = res[i].SQLID;
                        resultvalue.tenantID = res[i].TenantID;
                        resultvalue.alternate = res[i].Alternate;
                        resultvalue.billToRemitTo = res[i].BillToRemitTo;
                        resultvalue.collectionPoint = res[i].CollectionPoint;
                        resultvalue.contactDetails = res[i].ContactDetails;
                        resultvalue.contactRemarks = res[i].ContactRemarks;
                        resultvalue.farms = res[i].Farms;
                        resultvalue.federalRegisteredName = res[i].FederalRegisteredName;
                        //    resultvalue.licenses =  res[i].ProductLicenses ? res[i].ProductLicenses.Items.filter(i=>i).map(d => { let obj = d; delete obj._Entity; return obj }) : null;
                        resultvalue.licenses = res[i].ProductLicenses ? res[i].ProductLicenses : null;
                        resultvalue.addressline1 = res[i].AddressLine1;
                        resultvalue.addressline2 = res[i].AddressLine2;
                        returnarray.push(resultvalue);
                    }
                    callback(returnarray);
                }
            }, (error) => {
                faildcallback(error)
            }
        );
    }
    public GetCustomerCreditDetails(customerNameId: string): Promise<any> {

        return new Promise((resolve, reject) => {
            let tenantID = this.storage.getTenantID();
            if (!tenantID)
                return;

            customerNameId = customerNameId.replaceAll("'", "''");
            //let location = utils.getLocation();
            this.helper.PostServerCommand(
                `/culturahub/RESTCommandWebService/ExecuteServerCommand/ARBalanceProcessor/GetARBalancesByNameID?TenantID=${tenantID}&NameID=,${customerNameId}`, null, (data) => {
                    if (data) {
                        let returnObj: CustomerCredit = new CustomerCredit();
                        returnObj.balance = data.Items.map(e => e.AccountBalance).reduce((a, b) => a + b, 0);
                        returnObj.current = data.Items.map(e => e.UnpaidCurrentPeriod).reduce((a, b) => a + b, 0);
                        returnObj.pastDue = data.Items.map(e => e.UnpaidAgedCategory1 + e.UnpaidAgedCategory2 + e.UnpaidAgedCategory3 + e.UnpaidAgedCategory4 + e.UnpaidAgedCategory5 + e.UnpaidAgedCategory6).reduce((a, b) => a + b, 0);
                        returnObj.prepay = data.Items.map(e => e.PrepaidBalance).reduce((a, b) => a + b, 0);
                        returnObj.booking = data.Items.map(e => e.BookingBalance).reduce((a, b) => a + b, 0);
                        resolve(returnObj);
                    }

                }, (error) => {
                    reject(error)
                }
            )
        })
    }
    //127.0.0.1:8080/agrispsql/RESTCommandWebService/ExecuteServerCommand/CustomerProcessor/GetCustomers
    //?TenantID=133d19ba-aa22-4c1a-8c8a-132757517d8f&SelectedEntities=[Customer:ContactDetails,ContactRemarks]&AccountSinceDate=2015-01-01
    //${remote}/culturahub/RESTActivityWebService/agris.relational/Customers?Where=<<Customer.AccountSinceDate>> > ?&param0=1900-01-01
    //&City=GREENLEAF&NameDescription=ZIRBEL JR, ROBERT F&PhoneNumber=(920) 864-2230
    public syncCustomersLive(tenantID, date, nameDescription, city, phoneNumber, nameId, callback, faildcallback) {
        let location = utils.getLocation();
        let settings = this.storage.get(StorageKeys.Settings);

        let numberOfCustomersInSearchResult = utils.getNumberOfCustomersInSearchResult();
        this.helper.PostServerCommand(
            `/culturahub/RESTCommandWebService/ExecuteServerCommand/CustomerProcessor/GetCustomers?TenantID=${tenantID}&SelectedEntities=[Customer:ContactDetails,ProductLicenses]&AccountSinceDate=${date}&City=${city}&NameDescription=${nameDescription}&NameID=${nameId}&PhoneNumber=${phoneNumber}&TopN=${numberOfCustomersInSearchResult}&InventoryLocation=${location}&NameIdTypeStart=${settings.startNameIdType}&NameIdTypeEnd=${settings.endNameIdType}`, null,
            (data) => {
                if (data) {
                    let arr = [];
                    //  arr = (data.Items.map(d => { let obj = d; delete obj._Entity; return obj }));
                    arr = data;
                    callback(arr);
                }

            }, (error) => {
                faildcallback(error)
            }
        )
    }
    public getBillToCustomer(customerId: string): Promise<any> {
        return new Promise((resolve, reject) => {
            let url;
            let agentType = localStorage.getItem("AgentType");
            let dataSet = this.storage.get(StorageKeys.DataSet);
            let settings = this.storage.get(StorageKeys.Settings);

            if (agentType == "SQL") {
                url = `/culturahub/RESTActivityWebService/agris.relational/BillToRemitTo?where=<<BillToRemitTo.TenantID>> eq ? and <<BillToRemitTo.NameID>> eq ? &param0=${dataSet.TenantID}&param1=${customerId}`
            } else {
                url = `/culturahub/RESTActivityWebService/agris.relational/BillToRemitTo?NameID=${customerId}`
            }
            let customerKey = settings.customerKey;
            let SessionID = settings.agentSessionId;
            if (settings.remoteServer == undefined) {
                settings.remoteServer = utils.GetGetwayRemoteDomain();
            }
            this.helper.Get(settings.remoteServer + url, customerKey, SessionID, null, (data) => {
                if (data && data.length > 0)
                    resolve(data[0].BillToRemitToNameID);
                else
                    reject(data)
            }, (error) => {
                reject(error.error);
            }, dataSet.TenantID, 'CrossTenantQuery|true')
        });
    }
    public GetCustomersLiveFromNameAddress(customerRequest: CustomerRequest, emailType = ""): Promise<any> {

        return new Promise((resolve, reject) => {
            let tenantID = this.storage.getTenantID();
            if (!tenantID)
                return;
            this.syncCustomersLiveFromNameAddress(tenantID, ``, customerRequest.name, customerRequest.city, customerRequest.phoneNumber, customerRequest.nameId, emailType, 'contains')
                .then(data => {
                    if (data) {
                        resolve(data);
                    } else {
                        reject();

                    }
                }, (error) => {
                    reject(error);
                });
        })
    }
    public syncCustomersLiveFromNameAddress(tenantID, date, nameDescription, city, phoneNumber, nameId, emailType, descriptionSearchFilter) {


        return new Promise((resolve, reject) => {
            let location = utils.getLocation();
            let description = nameDescription.trim();//encodeURIComponent(nameDescription);
            let params = [];
            // descriptionSearchFilter ='';

            let agentType = localStorage.getItem('AgentType');
            let settings = this.storage.get(StorageKeys.Settings);
            let dataSet = this.storage.get(StorageKeys.DataSet);
            // agentType == 'SQL' && tenantID ? params.push(`<<NameAddress.TenantID>> eq '${tenantID}'`) : '';
            // nameId ? params.push(`<<NameAddress.NameID>> ${descriptionSearchFilter}'${nameId.trim()}'`) : '';
            // description ? params.push(`<<NameAddress.NameDescription>> ${descriptionSearchFilter}  '${description.trim()}'`) : '';
            // city ? params.push(`<<NameAddress.City>> ${descriptionSearchFilter}  '${city.trim()}'`) : '';
            // phoneNumber ? params.push(`<<NameAddress.PhoneNumber>> eq '${phoneNumber}'  AND <<NameAddress.ActiveStatus>> eq 'A'`) : '';

            let customerKey = settings.customerKey;
            let SessionID = settings.agentSessionId;
            if (settings.remoteServer == undefined) {
                settings.remoteServer = utils.GetGetwayRemoteDomain();
            }
            // let url = `/culturahub/RESTActivityWebService/agris.relational/NameAddress?Where=`;

            let url = `/culturahub/RESTActivityWebService/agris.relational/NameAddress?where=<<NameAddress.NameID>> contains  ? and <<NameAddress.NameDescription>> contains  ? and <<NameAddress.City>> contains  ? and <<NameAddress.PhoneNumber>> contains  ? &param0=${nameId.trim().toUpperCase()}&param1=${description.trim().toUpperCase()}&param2=${city.trim().toUpperCase()}&param3=${phoneNumber.trim().toUpperCase()}`
            if (agentType == 'SQL') {
                url = `/culturahub/RESTActivityWebService/agris.relational/NameAddress?where=<<NameAddress.TenantID>> eq ? and <<NameAddress.NameID>> contains  ? and <<NameAddress.NameDescription>> contains  ? and <<NameAddress.City>> contains  ? and <<NameAddress.PhoneNumber>> contains  ? &param0=${tenantID}&param1=${nameId.trim().toUpperCase()}&param2=${description.trim().toUpperCase()}&param3=${city.trim().toUpperCase()}&param4=${phoneNumber.trim().toUpperCase()}`
            }
            params.forEach((param, i) => {
                url = `${url}${(i > 0) ? ' and ' : ''}${param}`
            });
            let numberOfCustomersInSearchResult = utils.getNumberOfCustomersInSearchResult();
            this.helper.Get(settings.remoteServer + url, customerKey, SessionID, '[NameAddress:ContactDetails]',
                (res) => {
                    if (res) {
                        let returnarray: CustomerDetails[] = [];
                        for (var i = 0; i < res.length; i++) {
                            let resultvalue = new CustomerDetails();
                            resultvalue.name = res[i].NameDescription;
                            resultvalue.city = res[i].City;
                            resultvalue.state = res[i].State;
                            resultvalue.nameId = res[i].NameID;
                            resultvalue.Id = res[i].NameID;
                            resultvalue.phoneNumber = res[i].PhoneNumber;
                            resultvalue.accountSinceDate = res[i].AccountSinceDate;
                            resultvalue.accumulatePatronage = res[i].AccumulatePatronage;
                            resultvalue.activeStatus = res[i].ActiveStatus;
                            resultvalue.accountSinceDate = res[i].accountSinceDate;
                            resultvalue.addressLine1Partial = res[i].AddressLine1Partial;
                            resultvalue.addressLine2Partial = res[i].AddressLine2Partial;
                            resultvalue.bankDefaultACP = res[i].BankDefaultACP;
                            resultvalue.bankDefaultACR = res[i].BankDefaultACR;
                            resultvalue.bankDefaultGRNCheck = res[i].BankDefaultGRNCheck;
                            resultvalue.bankDefaultGRNReceipt = res[i].BankDefaultGRNReceipt;
                            resultvalue.chargeTax1 = res[i].ChargeTax1;
                            resultvalue.chargeTax2 = res[i].ChargeTax2;
                            resultvalue.chargeTax3 = res[i].ChargeTax3;
                            resultvalue.chargeTax4 = res[i].ChargeTax4;
                            resultvalue.cityPartial = res[i].CityPartial;
                            resultvalue.commodityDiscountTable = res[i].CommodityDiscountTable;
                            resultvalue.country = res[i].Country;
                            resultvalue.currencyCode = res[i].CurrencyCode;
                            resultvalue.deferredPayDate = res[i].DeferredPayDate;
                            resultvalue.financeChargeTable = res[i].FinanceChargeTable;
                            resultvalue.invoiceTerms = res[i].InvoiceTerms;
                            resultvalue.misc1Code = res[i].Misc1Code;
                            resultvalue.misc2Code = res[i].Misc2Code;
                            resultvalue.misc3Code = res[i].Misc3Code;
                            resultvalue.misc3CodeDV = res[i].Misc3CodeDV;
                            resultvalue.misc4Code = res[i].Misc4Code;
                            resultvalue.misc5Code = res[i].Misc5Code;
                            resultvalue.misc6Code = res[i].Misc6Code;
                            resultvalue.nameIdType = res[i].NameIdType;
                            resultvalue.nameIdTypeDV = res[i].NameIdTypeDV;
                            resultvalue.namePartial1of3 = res[i].NamePartial1of3;
                            resultvalue.namePartial2of3 = res[i].NamePartial2of3;
                            resultvalue.otherReference = res[i].OtherReference;
                            resultvalue.parentNameID = res[i].ParentNameID;
                            resultvalue.priceLevel = res[i].PriceLevel;
                            resultvalue.priceSchedule = res[i].PriceSchedule;
                            resultvalue.purchaseCreditLimit = res[i].PurchaseCreditLimit;
                            resultvalue.remark1 = res[i].Remark1;
                            resultvalue.remark2 = res[i].Remark2;
                            resultvalue.requireTheirDocumentNumber = res[i].RequireTheirDocumentNumber;
                            resultvalue.salesCreditLimit = res[i].SalesCreditLimit;
                            resultvalue.socialSecurityFederalId = res[i].SocialSecurityFederalId;
                            resultvalue.stateCode = res[i].StateCode;
                            resultvalue.tran1Code = res[i].Tran1Code;
                            resultvalue.tran2Code = res[i].Tran2Code;
                            resultvalue.tran3Code = res[i].Tran3Code;
                            resultvalue.tran4Code = res[i].Tran4Code;
                            resultvalue.tran5Code = res[i].Tran5Code;
                            resultvalue.voucherTerms = res[i].VoucherTerms;
                            resultvalue.zipCode = res[i].ZipCode;
                            resultvalue.cityStateZip = res[i].CityStateZip;
                            resultvalue.createdBy = res[i].CreatedBy;
                            resultvalue.createdDate = res[i].CreatedDate;
                            resultvalue.lastUpdatedBy = res[i].LastUpdatedBy;
                            resultvalue.lastUpdatedDate = res[i].LastUpdatedDate;
                            resultvalue.sqlID = res[i].SQLID;
                            resultvalue.tenantID = res[i].TenantID;
                            resultvalue.alternate = res[i].Alternate;
                            resultvalue.billToRemitTo = res[i].BillToRemitTo;
                            resultvalue.collectionPoint = res[i].CollectionPoint;
                            resultvalue.contactDetails = res[i].ContactDetails;
                            resultvalue.contactRemarks = res[i].ContactRemarks;
                            resultvalue.farms = res[i].Farms;
                            resultvalue.federalRegisteredName = res[i].FederalRegisteredName;
                            //    resultvalue.licenses =  res[i].ProductLicenses ? res[i].ProductLicenses.Items.filter(i=>i).map(d => { let obj = d; delete obj._Entity; return obj }) : null;
                            resultvalue.licenses = res[i].ProductLicenses ? res[i].ProductLicenses : null;
                            resultvalue.addressline1 = res[i].AddressLine1;
                            resultvalue.addressline2 = res[i].AddressLine2;
                            if (res[i].ContactDetails) {
                                resultvalue.primaryContact =
                                    res[i].ContactDetails.filter((contactDetail) => {
                                        return contactDetail.ContactCategory == "E" && contactDetail.PrimaryContact == "Y" && contactDetail.NameID == resultvalue.nameId;
                                    });
                            }
                            let contacts: any = resultvalue.contactDetails;
                            if (contacts && contacts.length > 0) {
                                contacts = contacts.filter((x: any) => x.ContactType == emailType) || [];
                                contacts = contacts.filter((x: any) => x.NameID == resultvalue.nameId) || [];
                                if (contacts.length > 0) {
                                    contacts = contacts.filter((x: any) => this.utilService.validateEmail(x.ContactInformation) == true);
                                    resultvalue.mailToEmails = contacts.map((x: any) => x.ContactInformation).join(";");
                                    resultvalue.mailToEmails = resultvalue.mailToEmails + ';';
                                }
                            }
                            resultvalue.primaryContact = resultvalue.primaryContact.length > 0 ? resultvalue.primaryContact[0] : '';
                            returnarray.push(resultvalue);
                        }

                        resolve(returnarray);
                    }
                    //resolve(itemList);

                }, (error) => {
                    reject(error.error);
                }, tenantID, `CrossTenantQuery|True|TopN|${numberOfCustomersInSearchResult}`)
            //`${agentType == 'SQL' ? `TopN|${numberOfCustomersInSearchResult}|CrossTenantQuery|true|NameAddress.OrderBy|Order By <<NameAddress.Description>> ASC` : `TopN|${numberOfCustomersInSearchResult}|NameAddress.OrderBy|Order By <<NameAddress.Description>> ASC`}`
        });


    }
    public getFarmsByCustomer(customerId: string): Promise<any> {
        return new Promise((resolve, reject) => {
            let url;
            let agentType = localStorage.getItem("AgentType");
            let dataSet = this.storage.get(StorageKeys.DataSet);
            let settings = this.storage.get(StorageKeys.Settings);

            if (agentType == "SQL") {
                url = `/culturahub/RESTActivityWebService/agris.relational/FarmAGY?where=<<FarmAGY.TenantID>> eq ? and <<FarmAGY.ClientId>> eq ? &param0=${dataSet.TenantID}&param1=${customerId}`
            } else {
                url = `/culturahub/RESTActivityWebService/agris.relational/FarmAGY?ClientId=${customerId}`
            }
            let customerKey = settings.customerKey;
            let SessionID = settings.agentSessionId;
            if (settings.remoteServer == undefined) {
                settings.remoteServer = utils.GetGetwayRemoteDomain();
            }
            this.helper.Get(settings.remoteServer + url, customerKey, SessionID, "[FarmAGY:FarmSplits]", (data) => {
                if (data && data.length > 0)
                    resolve(data);
                else
                    resolve([])
            }, (error) => {
                if (error.status == 404)
                    resolve([])
                reject(error.error);
            }, dataSet.TenantID, 'CrossTenantQuery|true')
        });
    }
    public getFieldsWithSplitsByFarm(farmCode: string): Promise<any> {
        return new Promise((resolve, reject) => {
            let url;
            let agentType = localStorage.getItem("AgentType");
            let dataSet = this.storage.get(StorageKeys.DataSet);
            let settings = this.storage.get(StorageKeys.Settings);

            if (agentType == "SQL") {
                url = `/culturahub/RESTActivityWebService/agris.relational/FieldAGY?where=<<FieldAGY.TenantID>> eq ? and <<FieldAGY.FarmCode>> eq ? &param0=${dataSet.TenantID}&param1=${farmCode}`
            } else {
                url = `/culturahub/RESTActivityWebService/agris.relational/FieldAGY?FarmCode=${farmCode}`
            }
            let customerKey = settings.customerKey;
            let SessionID = settings.agentSessionId;
            if (settings.remoteServer == undefined) {
                settings.remoteServer = utils.GetGetwayRemoteDomain();
            }
            this.helper.Get(settings.remoteServer + url, customerKey, SessionID, "[FieldAGY:FieldSplits]", (data) => {
                if (data && data.length > 0)
                    resolve(data);
                else
                    resolve([])
            }, (error) => {
                if (error.status == 404)
                    resolve([])
                reject(error.error);
            }, dataSet.TenantID, 'CrossTenantQuery|true')
        });
    }
    public getSplitsByClientId(ClientId: string): Promise<any> {
        return new Promise((resolve, reject) => {
            let url;
            let agentType = localStorage.getItem("AgentType");
            let dataSet = this.storage.get(StorageKeys.DataSet);
            let settings = this.storage.get(StorageKeys.Settings);

            // if (agentType == "SQL") {
            //     url = `/culturahub/RESTActivityWebService/agris.relational/clientsplit?where=<<clientsplit.TenantID>> eq ? and (<<clientsplit.ClientId>> eq ? or <<clientsplit.SplitClientId>> eq ? )&param0=${dataSet.TenantID}&param1=${customerId}&param2=${customerId}`
            // } else {
            //     url = `/culturahub/RESTActivityWebService/agris.relational/clientsplit??where=<<clientsplit.ClientId>> eq ? or <<clientsplit.SplitClientId>> eq ? &param0=${customerId}&param1=${customerId}`
            // }

            if (agentType == "SQL") {
                url = `/culturahub/RESTActivityWebService/agris.relational/clientsplit?where=<<clientsplit.TenantID>> eq ? and <<clientsplit.ClientId>> eq ? &param0=${dataSet.TenantID}&param1=${ClientId}`
            } else {
                url = `/culturahub/RESTActivityWebService/agris.relational/clientsplit?ClientId=${ClientId}`
            }
            let customerKey = settings.customerKey;
            let SessionID = settings.agentSessionId;
            if (settings.remoteServer == undefined) {
                settings.remoteServer = utils.GetGetwayRemoteDomain();
            }
            this.helper.Get(settings.remoteServer + url, customerKey, SessionID, null, (data) => {
                if (data && data.length > 0)
                    resolve(data);
                else
                    resolve([])
            }, (error) => {
                if (error.status == 404)
                    resolve([])
                reject(error.error);
            }, dataSet.TenantID, 'CrossTenantQuery|true')
        });
    }
    public getSplitsBySplitClientId(splitClientId: string): Promise<any> {
        return new Promise((resolve, reject) => {
            let url;
            let agentType = localStorage.getItem("AgentType");
            let dataSet = this.storage.get(StorageKeys.DataSet);
            let settings = this.storage.get(StorageKeys.Settings);

            // if (agentType == "SQL") {
            //     url = `/culturahub/RESTActivityWebService/agris.relational/clientsplit?where=<<clientsplit.TenantID>> eq ? and (<<clientsplit.ClientId>> eq ? or <<clientsplit.SplitClientId>> eq ? )&param0=${dataSet.TenantID}&param1=${customerId}&param2=${customerId}`
            // } else {
            //     url = `/culturahub/RESTActivityWebService/agris.relational/clientsplit??where=<<clientsplit.ClientId>> eq ? or <<clientsplit.SplitClientId>> eq ? &param0=${customerId}&param1=${customerId}`
            // }

            if (agentType == "SQL") {
                url = `/culturahub/RESTActivityWebService/agris.relational/clientsplit?where=<<clientsplit.TenantID>> eq ? and <<clientsplit.SplitClientId>> eq ? &param0=${dataSet.TenantID}&param1=${splitClientId}`
            } else {
                url = `/culturahub/RESTActivityWebService/agris.relational/clientsplit?SplitClientId=${splitClientId}`
            }
            let customerKey = settings.customerKey;
            let SessionID = settings.agentSessionId;
            if (settings.remoteServer == undefined) {
                settings.remoteServer = utils.GetGetwayRemoteDomain();
            }
            this.helper.Get(settings.remoteServer + url, customerKey, SessionID, null, (data) => {
                if (data && data.length > 0)
                    resolve(data);
                else
                    resolve([])
            }, (error) => {
                if (error.status == 404)
                    resolve([])
                reject(error.error);
            }, dataSet.TenantID, 'CrossTenantQuery|true')
        });
    }
}